const PERMISSION_KEY= "personalize:nebula_performance_logs";
const PAGE_URL = {
    NEBULA_PERFORMANCE_LOG_PAGE: "/admin/personalize/nebula-performance-log"
}

export {PERMISSION_KEY, PAGE_URL}

